module.exports = __webpack_public_path__ + "media/images/brand/banner/background_400-8e6e7a6d4d1aa8bf02896f9375e05779.png";